/* klucze muszą mieć numeryczne wartości w celu szybszych wyszukiwań */

/* { key: 2, value: 2, text: 'motocykl' } */

const vehicle_types = [
  { key: 1, value: 1, text: 'osobowe' },
];

export default vehicle_types; 